import React, { useState, useEffect, useContext } from "react";
import API from "../../../Functions/API/api";
import "./Subject.css";
import { FaEdit } from "react-icons/fa";
import { AuthContext } from "../../../context/authContext";


const Subjects = () => {
  const { user } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);
  const [currentSubject, setCurrentSubject] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    link: "",
  });
  const [editModal, setEditModal] = useState(false);
  const [currentTopic, setCurrentTopic] = useState(null);

  const [Subjects, setSubjects] = useState([
    {
      title: "Geometry",
      subtitle:
        "Elementary Geometry, your first step into the beauty of Olympiad-style thinking.",
      color: "linear-gradient(135deg, #FF7A18, #FFB347)",
      icon: "📐",
      topics: [],
    },
    {
      title: "Combinatorics",
      subtitle:
        "Unlocking the secrets of counting and arrangement in Olympiad-style problems.",
      color: "linear-gradient(135deg, #2E3192, #1BFFFF)",
      icon: "🎲",
      topics: [],
    },
    {
      title: "Number Theory",
      subtitle:
        "Where the elegance of primes guides you through Olympiad challenges.",
      color: "linear-gradient(135deg, #11998E, #38EF7D)",
      icon: "🔢",
      topics: [],
    },
    {
      title: "Algebra",
      subtitle:
        "The foundation of problem-solving with equations and structures in the Olympiad world.",
      color: "linear-gradient(135deg, #8E2DE2, #4A00E0)",
      icon: "∑",
      topics: [],
    },
  ]);

  // Fetch topics for each subject
  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const updatedSubjects = await Promise.all(
          Subjects.map(async (subject) => {
            const res = await fetch(
              `https://server.mathtounsi.com/api/courses/${subject.title}`
            );
            const data = await res.json();
            return { ...subject, topics: data };
          })
        );
        setSubjects(updatedSubjects);
      } catch (err) {
        console.error("Error fetching topics:", err);
      }
    };

    fetchTopics();
  }, []);

  return (
    <div className="subjects-grid">
      {Subjects.map((subject, i) => (
        <div key={i} className="subject-card">
          <div className="subject-header" style={{ background: subject.color }}>
            <span className="subject-icon">{subject.icon}</span>
            <div>
              <h2>{subject.title}</h2>
              <p>{subject.subtitle}</p>
            </div>
            {user?.role === "Admin" ? (
              <button
                onClick={() => {
                  setCurrentSubject(subject.title);
                  setShowModal(true);
                }}
              >
                Expand
              </button>
            ) : null}
          </div>

          <div className="subject-topics scrollable-topics">
            {subject.topics.length === 0 ? (
              <p>no course is available.</p>
            ) : (
              subject.topics.map((topic, j) => (
                <div key={j} className="topic-card">
                  <div className="Topic-Description" onClick={() => {
    window.open(topic.link, "_blank"); 
    // "_blank" opens in a new tab/fenetre
  }}>
                    <h3>{topic.name}</h3>
                    <p>{topic.description}</p>
                  </div>
                  {user?.role === "Admin" ? (
                    <button
                      onClick={() => {
                        setCurrentSubject(subject.title);
                        setCurrentTopic(topic);
                        setFormData({
                          name: topic.name,
                          description: topic.description,
                          link: topic.link || "",
                        });
                        setEditModal(true);
                      }}
                    >
                      <FaEdit className="edit-icon" />
                    </button>
                  ) : null}
                </div>
              ))
            )}
          </div>
        </div>
      ))}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Add Topic to {currentSubject}</h2>
            <form
              onSubmit={async (e) => {
                e.preventDefault();
                try {
                  const res = await API.post(
                    "/courses",
                    {
                      subject: currentSubject,
                      ...formData,
                    }
                  );

                  const newTopic = res.data;

                  // Update state instantly
                  setSubjects((prev) =>
                    prev.map((s) =>
                      s.title === currentSubject
                        ? { ...s, topics: [...s.topics, newTopic] }
                        : s
                    )
                  );

                  // Reset form + close modal
                  setFormData({ name: "", description: "", link: "" });
                  setShowModal(false);
                } catch (err) {
                  console.error(err);
                  alert("Error adding topic");
                }
              }}
            >
              <input
                type="text"
                placeholder="Topic name"
                value={formData.name}
                required
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
              <textarea
                placeholder="Description"
                value={formData.description}
                required
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
              />
              <input
                type="url"
                placeholder="Link"
                value={formData.link}
                required
                onChange={(e) =>
                  setFormData({ ...formData, link: e.target.value })
                }
              />
              <div className="modal-actions">
                <button type="submit">Add</button>
                <button type="button" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {editModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Edit Topic in {currentSubject}</h2>
            <form
              onSubmit={async (e) => {
                e.preventDefault();
                try {
                  const res = await API.put(
                    `/courses/${currentTopic._id}`,
                    {
                      subject: currentSubject,
                      ...formData,
                    }
                  );

                  const updatedTopic = res.data;

                  // Update UI
                  setSubjects((prev) =>
                    prev.map((s) =>
                      s.title === currentSubject
                        ? {
                            ...s,
                            topics: s.topics.map((t) =>
                              t._id === updatedTopic._id ? updatedTopic : t
                            ),
                          }
                        : s
                    )
                  );

                  setEditModal(false);
                  setCurrentTopic(null);
                } catch (err) {
                  console.error(err);
                  alert("Error updating topic");
                }
              }}
            >
              <input
                type="text"
                placeholder="Topic name"
                value={formData.name}
                required
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
              <textarea
                placeholder="Description"
                value={formData.description}
                required
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
              />
              <input
                type="url"
                placeholder="Link"
                value={formData.link}
                required
                onChange={(e) =>
                  setFormData({ ...formData, link: e.target.value })
                }
              />

              <div className="modal-actions">
                <button type="submit">Save</button>
                <button
                  type="button"
                  onClick={async () => {
                    if (
                      !window.confirm(
                        "Are you sure you want to delete this topic?"
                      )
                    )
                      return;
                    try {
                      await API.delete(
                        `/courses/${currentTopic._id}`
                      );

                      // Remove from UI
                      setSubjects((prev) =>
                        prev.map((s) =>
                          s.title === currentSubject
                            ? {
                                ...s,
                                topics: s.topics.filter(
                                  (t) => t._id !== currentTopic._id
                                ),
                              }
                            : s
                        )
                      );

                      setEditModal(false);
                      setCurrentTopic(null);
                    } catch (err) {
                      console.error(err);
                      alert("Error deleting topic");
                    }
                  }}
                >
                  Delete
                </button>
                <button type="button" onClick={() => {setCurrentSubject(null);
                        setCurrentTopic(null);
                        setFormData({
                          name: "",
                          description: "",
                          link: "",
                        });
                        setEditModal(false);
                      }}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Subjects;
